



































import { Component, Vue } from 'vue-property-decorator';
import { mdbBtn } from '@folky-tools/mdbvue';
import { authenticationService } from '@/services';

@Component({
    components: {
        mdbBtn
    }
})
export default class CampaignSurveyView extends Vue {
    private userId: number | undefined = undefined;

    get cookieName(): string {
        return process.env.NODE_ENV === 'production' ? `.App.Campaign${this.$route.params.id}SurveyPostponed` : `.App.MC-${process.env.NODE_ENV}.Campaign${this.$route.params.id}SurveyPostponed`;
    }

    private async beforeMount(): Promise<void> {
        this.userId = await authenticationService.getUserId;
    }

    private mounted(): void {
        this.$root.$emit('change-active-page', 'views.surveys.campaignSurveyView.campaign.' + this.$route.params.id + '.title');
    }

    private stopAsking() {
        this.postponeSurvey(365);
        this.$router.push({ name: 'dashboard' });
    }

    private postponeSurvey(daysToPostpone: number): void {
        this.setCookie(this.cookieName, 1, daysToPostpone, '', '/');
    }

    private setCookie(name: string, value: number, expiryDays: number, domain: string, path: string): void {
        const exdate = new Date();
        exdate.setDate(exdate.getDate() + (expiryDays || 365));

        const cookie = [`${name}=${value}`, `expires=${exdate.toUTCString()}`, `path=${path || '/'}`];

        if (domain) {
            cookie.push(`domain=${domain}`);
        }

        document.cookie = cookie.join(';');
    }

    private getCookie(name: string): string | undefined {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);

        return parts.length !== 2 ? undefined : parts.pop()!.split(';').shift();
    }
}
